export default __webpack_public_path__ + "static/media/s3.55e498ab.png";